<style lang='scss' scoped>

</style>

<template>
    <div class="el-tabs el-tabs--top el-tabs--border-card">
        <div class="el-tabs__header is-top">
            <div class="el-tabs__nav-wrap is-top">
                <div class="el-tabs__nav-scroll flex-row-between">
                    <div class="el-tabs__nav is-top" >
                        <div
                            class="el-tabs__item is-top"
                            id="modifyTab"
                            @click="tabItemClick(item)"
                            v-for="item in navList.children"
                            v-if="!item.hidden"
                            :key="item.path"
                            :class="{'is-active': item.path === $route.path}">
                            {{item.name}}
                        </div>
                    </div>
                    <div class="MR-10">
                        <slot name="append"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="el-tabs__content">
            <transition name="el-fade-in-linear" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
import { find } from 'underscore'
let bool = false
export default {
    data() {
        return {
            navList: null
        }
    },
    props: {
        // 取第几级的路由为当前展示级
        level: {
            type: Number,
            default: 1
        }
    },
    created() {
        this.initRouter()
    },
    mounted() {

    },
    computed: {

    },
    watch: {

    },
    components: {

    },
    methods: {
        initRouter() {
            let curRouterPath = this.$route.path
            let routers = this.$router.options.routes
            let arr = this.getPathByKey(curRouterPath, 'path', routers)
            if (arr.length >= this.level) {
                this.navList = arr[this.level]
            } else {
                this.navList = arr[0]
            }
            
            if (this.navList && this.navList.children && this.navList.children.length > 0) {
                let route = find(this.navList.children, item => {
                    if (item.path === curRouterPath) {
                        return true
                    }
                })
                !route && this.$router.push({
                    path: this.navList.children[0].path
                })
            }
        },
        /**
         * 点击某个item
         */
        tabItemClick(item) {
            let id = ''
            if (item.path == '/stock/list/info/modelList' || item.path == '/stock/list/info/param') {
                id = this.$route.query.id
            }
            let url = item.path
            if (id) {
                url = `${item.path}?id=${id}`
            }
            this.$router.push({
                path: url
            })
            this.$emit('tab-click')
        },
        /**
         * 获取树结构路径
         */
        getPathByKey(value, key, arr) {
            let temppath = [];
            try {
                function getNodePath(node){
                    temppath.push(node);
                    if (node[key] === value) {
                        throw ("GOT IT!");
                    }
                    if (node.children && node.children.length > 0) {
                        for (var i = 0; i < node.children.length; i++) {
                            getNodePath(node.children[i]);
                        }
                        temppath.pop();
                    } else { 
                        temppath.pop();
                    }
                }
                for (let i = 0; i < arr.length; i++) {
                    getNodePath(arr[i]);
                }
            } catch (e) {
                return temppath;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// Index.vue?726ab0ed